
import { useState } from 'react';
import CoachFinderModal from '../../../components/feature/CoachFinderModal';

export default function CoachingPrograms() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const coaches = [
    {
      name: 'Marckiee Moo',
      rank: 'Diamond Ranked',
      specialty: 'Aggressive Playstyle',
      rating: 4.9,
      students: 342,
      hourlyRate: 'Inquire',
      achievements: ['2x Regional Champion', 'Top 50 Global Ranking', '500+ Hours Coached']
    },
    {
      name: 'Future Bubble',
      rank: 'Diamond Ranked',
      specialty: 'Defensive Mastery',
      rating: 5.0,
      students: 428,
      hourlyRate: 'Inquire',
      achievements: ['3x Tournament Winner', 'Professional Player', '1000+ Hours Coached']
    },
    {
      name: 'Quakeroni',
      rank: 'Platinum Ranked',
      specialty: 'Combo Specialist',
      rating: 4.8,
      students: 289,
      hourlyRate: 'Inquire',
      achievements: ['Combo Master', 'Content Creator', '300+ Hours Coached']
    },
    {
      name: 'Poisonta',
      rank: 'Diamond Ranked',
      specialty: 'Tournament Prep',
      rating: 4.9,
      students: 395,
      hourlyRate: 'Inquire',
      achievements: ['Tournament Organizer', 'Strategy Expert', '800+ Hours Coached']
    }
  ];

  return (
    <>
      <section id="coaching-programs" className="py-20 px-6 bg-gray-800">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Meet Our Professional Coaches
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Learn from the best. Our coaches are experienced competitors who have proven themselves 
              in tournaments and helped hundreds of players reach their goals.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {coaches.map((coach, index) => (
              <div 
                key={index}
                className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300"
              >
                <div className="relative h-64 bg-gray-700 flex items-center justify-center">
                  <div className="w-24 h-24 flex items-center justify-center rounded-full bg-gray-600">
                    <i className="ri-user-line text-5xl text-gray-400"></i>
                  </div>
                  <div className="absolute top-4 right-4 bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {coach.rank}
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{coach.name}</h3>
                  <p className="text-purple-400 font-semibold mb-4">{coach.specialty}</p>

                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      <i className="ri-star-fill text-yellow-400 mr-1"></i>
                      <span className="text-white font-semibold">{coach.rating}</span>
                      <span className="text-gray-400 ml-2">({coach.students} students)</span>
                    </div>
                    <div className="text-purple-400 font-bold text-lg">{coach.hourlyRate}</div>
                  </div>

                  <div className="space-y-2 mb-6">
                    {coach.achievements.map((achievement, idx) => (
                      <div key={idx} className="flex items-center text-sm text-gray-300">
                        <i className="ri-medal-line text-purple-400 mr-2"></i>
                        {achievement}
                      </div>
                    ))}
                  </div>

                  <button 
                    onClick={() => setIsModalOpen(true)}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-calendar-line mr-2"></i>
                    Book Session
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl p-8 md:p-12 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Start Your Training Journey?
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Join thousands of players who have improved their skills and achieved their competitive goals 
              with our professional coaching programs.
            </p>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="bg-white text-purple-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-rocket-line mr-2"></i>
              Get Started Today
            </button>
          </div>
        </div>
      </section>

      <CoachFinderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
